/** Offline fallback — names/ids only. Prices always come from Google Sheets via the API. */
export const FALLBACK_API_PRODUCTS = [
  {
    id: 'lamp',
    name: 'Wooden Halo Lamp',
    slug: 'lamp',
    stock: 0,
    active: true,
    shortDescription: 'Handcrafted solid wood table lamp with a cozy ambient glow.',
    category: 'Ambient',
    imageUrl: '',
  },
  {
    id: 'moon',
    name: 'Moon Wall Hanging',
    slug: 'moon',
    stock: 0,
    active: true,
    shortDescription:
      'Handcrafted moon wall art with a detailed lunar surface and soft warm-white LED glow.',
    category: 'Ambient',
    imageUrl: '',
  },
];
